import"react";var a;!function(a){a[a.init=0]="init",a[a.play=1]="play",a[a.pause=2]="pause",a[a.end=3]="end"}(a||(a={}));
//# sourceMappingURL=useSpeech.js.map
